import i18next from 'i18next';

i18next.addResources('es_CL', 'FooterTop', {
  title: '¿Alguna duda o consulta? Llama a nuestro Call Center o escribe a nuestro Whatsapp'
});
